function hasAlarmError(record) {
  return Boolean(record) && Number(record.alarmError) === 1;
}

module.exports = {
  hasAlarmError: hasAlarmError
};
